"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parseUrlParms = function (str) {
    var pieces = str.split("&");
    var data = {};
    var i;
    var parts;
    // process each query pair
    for (i = 0; i < pieces.length; i += 1) {
        parts = pieces[i].split("=");
        if (parts.length < 2) {
            parts.push("");
        }
        data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
    }
    return data;
};
exports.default = parseUrlParms;
